import type { SupabaseClient } from '../supabase/client';
import type { Locality } from '../types/locality';

export const LOCALITY_SELECT =
  'id, symbol_number, name_ar, name_he, name_en, itm_x, itm_y, created_at, updated_at, deleted_at' as const;

const LOCALITIES_PAGE_SIZE = 1000;

export async function listActiveLocalities(client: SupabaseClient): Promise<Locality[]> {
  const rows: Locality[] = [];
  let page = 0;

  while (true) {
    const from = page * LOCALITIES_PAGE_SIZE;
    const to = from + LOCALITIES_PAGE_SIZE - 1;
    const { data, error } = await client
      .from('localities')
      .select(LOCALITY_SELECT)
      .eq('active', true)
      .is('deleted_at', null)
      .order('name_ar', { ascending: true, nullsFirst: false })
      .order('name_he', { ascending: true })
      .range(from, to);

    if (error) throw error;

    const pageRows = (data ?? []) as unknown as Locality[];
    rows.push(...pageRows);

    if (pageRows.length < LOCALITIES_PAGE_SIZE) return rows;
    page += 1;
  }
}
